module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"attachementTitle":"Liste des pièces jointes"}}')
  delete Component.options._Ctor
}
